import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/serviceJobNote/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/serviceJobNote/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/serviceJobNote/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/serviceJobNote/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/serviceJobNote/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/serviceJobNote/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/serviceJobNote/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/serviceJobNote/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/serviceJobNote/UPDATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function loadServiceJobNotes(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/service-job-notes', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB_NOTE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadServiceJobNote(serviceJobNoteId){
  const options = new URLSearchParams([
    ['includes', 'serviceJobNoteType'],
    ['includes', 'user'],
  ])

  const promise = api(`/v1/service-job-notes/${serviceJobNoteId}`, options)
    .then(data => data)

  return promise
}

export function createServiceJobNote(serviceJobNote, options){
  const config = {
    method: 'POST',
    data: serviceJobNote,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/service-job-notes', options, config)
      .then(({ data }) => loadServiceJobNote(data))
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB_NOTE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateServiceJobNote(serviceJobNote, options){
  const config = {
    method: 'PUT',
    data: serviceJobNote,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-job-notes/${serviceJobNote.id}`, options, config)
      .then(({ data }) => {
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action
  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors,
        loaded: false,
        loading: false,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    default:
      return state
  }
}
